import { createContext } from "react";

/**
 * NOTE: The app shell prints the copyright on a line of its own under every
 * page. A page whose own bottom line keeps its end free for it — the started
 * chat, beside the composer's disclaimer — claims it through this setter: the
 * shell drops its line, so the page keeps that height, and draws the copyright
 * in that held space instead. Use `useClaimCopyrightLine` rather than calling
 * it directly.
 *
 * Null outside `AppLayout`, where there is no shell line to take over.
 */
export const CopyrightLineContext = createContext<
  ((isClaimed: boolean) => void) | null
>(null);
